import { Component } from '@verndale/core';
import Pristine from 'pristinejs';
import serialize from 'form-serialize';
import axios from 'axios';

import { SERIALIZE_SETTINGS } from '../utils/default-settings';
import { onlyIntegerNoLeadingZero } from '../utils/numbers';

import { dispatchGenericEvent } from '../utils/dispatch-events';
import { constEvent } from '../utils/constants';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $el: this.el,
      $form: this.el._$('form'),
      $quantity: this.el._$('form .field__input'),
      $btnAddToCart: this.el._$('form button[type="submit"]'),
      $btnAddToList: this.el._$('.buy-now-widget__atl-btn'),
      $btnCompare: this.el._$('.buy-now-widget__compare-btn'),
      $loginBtn: this.el._$('.buy-now-widget__info-small a'),
      $associateBtn: this.el._$('.buy-now-widget__info-wrapper .account-utility-nav-subnav__item a'),
      $message: this.el._$('.buy-now-widget__message')
    };
    this.pristine = null;
    this.pristineSettings = {
      classTo: 'field-wrapper',
      errorClass: 'field-wrapper--error',
      successClass: null,
      errorTextParent: null,
      errorTextTag: null,
      errorTextClass: null
    };
    this.showMessageClass = 'buy-now-widget__message--show';
    this.showMessageCenterClass = 'buy-now-widget__message--show-center';
    this.endpoint = this.dom.$form?.getAttribute('action') || null;

    this.init();
  } //setupDefaults

  addListeners() {
    const { $form, $quantity, $btnAddToList, $btnCompare, $loginBtn, $associateBtn } = this.dom;

    $form?._on('submit', this.addToCart.bind(this));
    $quantity?._on('input', this.validateQuantity.bind(this));
    $btnAddToList?._on('click', this.addToList.bind(this));
    $loginBtn?._on('click', this.showLogIn.bind(this));
    $associateBtn?._on('click', this.showAssociateAcc.bind(this));
    $btnCompare?._on('click', this.compareProducts.bind(this));

    if ($loginBtn) {
      const msgAttr = $loginBtn.parentNode.getAttribute('data-prompt-message');
      $loginBtn.setAttribute('data-open-login-modal', '');
      $loginBtn.setAttribute('data-prompt-message', msgAttr);
      $loginBtn.parentNode.removeAttribute('data-prompt-message');
    }
  } //addListeners

  init() {
    const { $btnAddToCart, $quantity } = this.dom;

    this.initPristine();

    if ($btnAddToCart) $btnAddToCart.disabled = false;
    if ($quantity) $quantity.disabled = false;

  } //init

  showLogIn(e) {
    e.preventDefault();
    const { $el } = this.dom;
    const { loggedIn, loginPromptMessage } = $el?.dataset || {};

    if (loggedIn !== 'true') {
      dispatchGenericEvent(constEvent.SHOW_MODAL_LOGIN, loginPromptMessage);
    }

  } //loginBtn


  showAssociateAcc(e) {
    e.preventDefault();
    dispatchGenericEvent(constEvent.SHOW_MODAL_LINK_ACCOUNT);
  } //Associate Account

  initPristine() {
    const { $form } = this.dom;

    if ($form) {
      this.pristine = new Pristine($form, this.pristineSettings);
    }
  } //initPristine

  addToCart(e) {
    e.preventDefault();
    const { $form, $message, $btnAddToCart } = this.dom;
    const valid = this.pristine.validate();

    if (valid) {
      const formData = serialize($form, SERIALIZE_SETTINGS);
      this.hideMessage();
      $btnAddToCart.disabled = true;

      this.post(this.endpoint, formData)
        .then(response => {
          const { success, body, message } = response?.data;

          if (success) {
            const { dispatchEvent } = body;
            if (dispatchEvent) {
              dispatchGenericEvent(dispatchEvent, body);
            }
          } else {
            $message.innerHTML = message;
            $message.classList.add(this.showMessageCenterClass);
          }
        })
        .finally(() => {
          $btnAddToCart.disabled = false;
        });
    } else {
      this.showQuantityErrorMessage();
    }
  } //addToCart

  validateQuantity(e) {
    const value = e.target.value;
    e.target.value = onlyIntegerNoLeadingZero(value);

    this.showQuantityErrorMessage();
  } //validateQuantity

  showQuantityErrorMessage() {
    const { $message } = this.dom;
    const errors = this.pristine.getErrors();

    if (errors.length) {
      const errorMessage =
        errors[0]?.input?.dataset?.pristineRequiredMessage || null;

      if (errorMessage) {
        $message.innerHTML = errorMessage;
        $message.classList.add(this.showMessageClass);
      }
    } else {
      this.hideMessage();
    }
  } //showQuantityErrorMessage

  hideMessage() {
    const { $message } = this.dom;

    $message.classList.remove(this.showMessageClass);
    $message.classList.remove(this.showMessageCenterClass);
  } //hideMessage

  addToList(e) {
    e.preventDefault();
    const { $btnAddToList } = this.dom;

    const productId = $btnAddToList?.getAttribute('data-product-id') || null;
    dispatchGenericEvent(constEvent.SHOW_ADD_TO_LIST_MODAL, productId);
  } //addToList

  compareProducts(e) {
    e.preventDefault();

    dispatchGenericEvent(constEvent.COMPARE_PRODUCTS);
  } //compareProducts

  post(endpoint, data) {
    return axios({
      method: 'post',
      url: endpoint,
      data,
      headers: {
        'content-type': 'application/json'
      }
    });
  } //post
}

export default Module;
